import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui';
import FlatDropDownMenu from '../../tc-ui/flatDropDownMenu';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { JiraFlatButton } from '../../tc-ui/small-buttons';
import { getStatusColor } from '../contractingUtils';

export const statuses = [
  'in progress',
  'pending',
  'in review',
  'complete',
  'accepted',
  'loaded',
  'loading',
  'rejected',
];

class UpdateRateConversionStatus extends Component {
  constructor() {
    super();
  }
  updateRCStatus = newStatus => () => {
    const { contractId, updateRCStatus } = this.props;
    updateRCStatus({ contractId, updater: { rateConversionStatus: newStatus } });
  };
  render() {
    const {
      rateConversionStatus = '',
    } = this.props;
    return (
      <FlatDropDownMenu
        button={
          <JiraFlatButton
            labelStyle={{ fontSize: '10px', color: getStatusColor(rateConversionStatus) }}
            icon={<ArrowDropDownIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', margin: 0 }}/>}
            labelPosition="before"
            label={rateConversionStatus}
          />
        }
      >
        {
          statuses.map(str => (
            <MenuItem
              key={str}
              primaryText={str}
              disabled={str === rateConversionStatus}
              onClick={this.updateRCStatus(str)}
            />
          ))
        }
      </FlatDropDownMenu>
    );
  }
}

UpdateRateConversionStatus.propTypes = {
  updateRCStatus: PropTypes.func,
  contractId: PropTypes.string,
  rateConversionStatus: PropTypes.string,
};

export default connect(null, ({
  updateRCStatus: payload => ({ type: '[contract-request] UPDATE_RATE_LOADING_STATUS', payload }),
}))(UpdateRateConversionStatus);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/update-rate-conversion-status.jsx